import React from 'react';
import { useParams } from 'react-router-dom';
import Page from '../../components/Page';
import PasswordBox from '../../components/PasswordBox';
import { Box, Typography, Card, CardContent, Stack } from '@mui/material';
import { verifySharedAccommodationCodeAction, getSharedAccommodationInfoForClient } from '../../services/request';
import { SharedAccommodationForm } from '../../sections/landing/order-forms/SharedAccommodationForm';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useQuery } from 'react-fetching-library';


export default function SharedAccommodation() {
  const [isCodeValid, setIsCodeValid] = React.useState(false);
  const [sharedAccommodationInfo, setSharedAccommodationInfo] = React.useState('');
  const [isSent, setIsSent] = React.useState(false);
  const { id } = useParams();

  const { loading, payload: payloadInfo, error } = useQuery(getSharedAccommodationInfoForClient(id));

  React.useEffect(() => {
    if (payloadInfo && !error && !loading) {
      setSharedAccommodationInfo(payloadInfo.shared_accommodation_info_for_client || '');
    }
  }, [payloadInfo, error, loading]);

  const handlePayload = payload => {
    setSharedAccommodationInfo(payload.shared_accommodation_info);
  };

  return (
    <Page title="Wspólne Zakwaterowanie">
      {isSent ? (
        <Box
          p={5}
          flexDirection="column"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Card>
            <CardContent>
              <Stack justifyContent="center" alignItems="center">
                <CheckCircleOutlineIcon
                  color="primary"
                  sx={{ fontSize: '100px', mb: 3 }}
                />
                <Typography variant="h3" textAlign="center" textTransform="none" fontWeight="normal">
                  Twoja prośba o wspólne zakwaterowanie została wysłana. Oczekuj na potwierdzenie.
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Box>
      ) : isCodeValid ? (
        <Box p={2}>
          <SharedAccommodationForm
            id={id}
            sharedAccommodationInfo={sharedAccommodationInfo}
            setIsSent={setIsSent}
          />
        </Box>
      ) : (
        <PasswordBox
          id={id}
          setIsCodeValid={setIsCodeValid}
          action={verifySharedAccommodationCodeAction}
          buttonText="Zweryfikuj"
          handlePayload={handlePayload}
          numbersOnly={false}
        />
      )}
    </Page>
  );
}
